import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import MDTypography from "components/MDTypography";

import { Grid, TextField, Table, TableBody, TableCell, TableRow, IconButton } from "@mui/material";
// import { useQuery } from "@tanstack/react-query";
import { FormTitle } from "ui-components/Form";
import { Fragment, useState, useEffect } from "react";
import { BackButton } from "layouts/views/components/Button";

// import { getLocationsByRack } from "services/data.internal.service";
// import DataTable from "examples/Tables/DataTable";
import { CancelButton } from "ui-components/IconButton";
import BasicTable from "ui-components/tables/BasicTable";
import { Error_ } from "ui-components/Alert";
import { StripedDataGrid } from "layouts/views/components/Grid";
import styled from "@emotion/styled";
import { selectionColumns } from "./column";
import { EditableSelectCustomOnChange } from "ui-components/EditableInput2";
import { useGridApiContext } from "@mui/x-data-grid";

const EditableStyledDataGrid = styled(StripedDataGrid)({
  ".custom-editable-header": {
    backgroundColor: "#1A73E8 !important",
    color: "#fff",
    fontWeight: "bold",
    whiteSpace: "normal !important",
  },
  ".MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal !important",
    lineHeight: 1,
  },
  ".MuiDataGrid-columnHeader": {
    backgroundColor: "#f0f2f5",
  },
  ".MuiDataGrid-cell": {
    whiteSpace: "normal !important",
    "word-wrap": "break-word !important",
  },
  ".right-align-header": {
    textAlign: "right",
  },
  ".highlight": {
    backgroundColor: "pink !important",
  },
});

const uomTypeOpt = ["BASE", "INNERPACK", "CASE", "PALLET"];

const customColumn = selectionColumns.filter(x => x.field !== "category" && x.field !== "group" && x.field !== "subgroup").map((x) => {
  if (x.field === "qtyToReplenish") {
    x.headerClassName = "custom-editable-header right-align-header";
    x.editable = true;
  }
  if (x.field === "uomType") {
    x.headerClassName = "custom-editable-header";
    x.editable = true;
    x.renderEditCell = (params) => {
      return <CustomPicker options={uomTypeOpt} {...params} />;
    };
  }
  return x;
});

const CustomPicker = (props) => {
  const { options, ...params } = props;
  const [selectedVal, setSelectedVal] = useState(params.value ? params.value : null);

  const apiRef = useGridApiContext();

  const handleValChange = async (e, value) => {
    setSelectedVal(value);
    await apiRef.current.setEditCellValue({
      id: params.id,
      field: params.field,
      value: value,
    });
  };

  return (
    <EditableSelectCustomOnChange
      getValue={() => selectedVal}
      onChange={handleValChange}
      options={options}
      style={{ width: "100%" }}
    />
  );
};

function RemovePickFaceLocationInfo(props) {
  const {
    warehouseCode,
    zoneID,
    rack,
    // locationsId,
    renderDialog,
    // selectedLocation,
    // setSelectedLocation,
    detail,
    setDetail,
    setAlert,
  } = props;

  // const [tableData, setTableData] = useState([]);
  // useQuery({
  //   queryKey: ["locations_by_rack", warehouseCode, zoneID, rack],
  //   queryFn: () =>
  //     getLocationsByRack({
  //       whCode: warehouseCode,
  //       id: zoneID,
  //       rack: rack,
  //     }),
  //   refetchOnWindowFocus: false,
  //   enabled: warehouseCode != "" && zoneID != "" && rack != "",
  //   onSuccess: (data) => {
  //     if (data.data) {
  //       const locations = data.data;
  //       let maxRow = Math.max.apply(
  //         Math,
  //         locations.map((x) => x.lLevel)
  //       );
  //       let maxColumn = Math.max.apply(
  //         Math,
  //         locations.map((x) => x.bay)
  //       );
  //       let numberOfSlot = Math.max.apply(
  //         Math,
  //         locations.map((x) => x.slot)
  //       );
  //       if (numberOfSlot > 0) maxColumn = maxColumn * numberOfSlot;
  //       let table = [];
  //       for (var i = 0; i < maxRow; i++) {
  //         let row = Array(maxColumn).fill("");
  //         let locationsInRow = locations.filter((x) => x.lLevel === i + 1);
  //         if (locationsInRow.length > 0) {
  //           for (var j = 0; j < locationsInRow.length; j++) {
  //             let index = (locationsInRow[j].bay - 1) * numberOfSlot + locationsInRow[j].slot - 1;
  //             row[index] = locationsInRow[j].locationID;
  //           }
  //         }
  //         table.unshift(row);
  //       }
  //       setTableData(table);
  //     }
  //   },
  // });

  // const columns = [
  //   { header: "Location ID", accessorKey: "locationId" },
  //   { header: "Customer Code", accessorKey: "customerCode" },
  //   { header: "Vendor Code", accessorKey: "vendorCode" },
  //   { header: "SKU Code", accessorKey: "skuCode" },
  //   { 
  //     header: "Action", 
  //     accessorKey: "action",
  //     enableColumnFilter: false,
  //     cell: ({row}) => {
  //       const {locationId, customerCode, vendorCode, skuCode} = row.original;
  //       return (
  //         <>
  //           <CancelButton
  //             title="remove pick face location detail"
  //             onClick={() => {
  //               renderDialog({
  //                 locationID: locationId,
  //                 customerCode: customerCode,
  //                 vendorCode: vendorCode,
  //                 skuCode: skuCode,
  //                 mode: "detail",
  //               });
  //             }}
  //           />
  //         </>
  //       );
  //     }
  //    },
  // ]

  const columns = [ {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 80,
    cellClassName: "actions",
    getActions :({ row }) => {
      const {locationId, customerCode, vendorCode, skuCode} = row;
      return [
        <>
          <CancelButton
              title="remove pick face location detail"
              onClick={() => {
                renderDialog({
                  locationID: locationId,
                  customerCode: customerCode,
                  vendorCode: vendorCode,
                  skuCode: skuCode,
                  mode: "detail",
                });
              }}
            />
        </>,
      ];
    },
  },
  {
    field: "locationId",
    headerName: "Location ID",
    sortable: false,
    align: "left",
    flex: 1.8,
    minWidth: 130,
  },
  ...customColumn]

  const handleProcessRowUpdateError = (error) => {
    setAlert(<Error_ content={error.toString()} onChange={setAlert} />);
  };

  const handleRowUpdate = (updatedRow, originalRow) => {
    if (JSON.stringify(updatedRow) !== JSON.stringify(originalRow)) {
      const newSKU = detail.map((x) => {
        if (
          x.locationId === updatedRow.locationId &&
          x.customerCode === updatedRow.customerCode &&
          x.skuCode === updatedRow.skuCode &&
          x.vendorCode === updatedRow.vendorCode
        ) {
          const updatedRowCopy = { ...x };
          updatedRowCopy.qtyToReplenish = updatedRow.qtyToReplenish;
          if (uomTypeOpt.some((uom) => uom === updatedRow.uomType)) {
            updatedRowCopy.uomType = updatedRow.uomType;
          } else {
            updatedRowCopy.uomType = null;
          }
          return updatedRowCopy;
        }
        return x;
      });

      setDetail(newSKU);
    }
    return updatedRow;
  };

  const isCellEditable = (params) => {
    if (params.field === "qtyToReplenish" || params.field === "uomType") {
      return Boolean(params.row.skuCode);
    }
    return false;
  };

  return (
    <MDBox>
      <>
        <FormTitle title="View Pick Face Location" />

        <MDBox mt={1.625}>
          <Fragment>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  sx={{ mb: 1.5 }}
                  value={warehouseCode}
                  fullWidth
                  label={"Warehouse Code"}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField sx={{ mb: 1.5 }} value={zoneID} fullWidth label={"Zone ID"} disabled />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField sx={{ mb: 1.5 }} value={rack} fullWidth label={"Rack"} disabled />
              </Grid>
            </Grid>
          </Fragment>

          {/* <Fragment> */}
            {/*front view table & Selection */}
            {/* <Grid container spacing={2}>
              <Grid item xs={6}>
                <MDBox pt={1} pb={2}>
                  <MDTypography color="info" variant="h5">
                    Select location to view details
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <LocationTable
                  tableData={tableData}
                  existingRecord={locationsId}
                  selectedLocation={selectedLocation}
                  setSelectedLocation={setSelectedLocation}
                />
              </Grid>
            </Grid>
          </Fragment> */}

          {Boolean(detail.length) && (
            <Fragment>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {/* <DataTable
                    table={{
                      columns: [
                        { Header: "Customer Code", accessor: "customerCode" },
                        { Header: "Vendor Code", accessor: "vendorCode" },
                        { Header: "SKU Code", accessor: "skuCode" },
                        { Header: "Action", accessor: "action" },
                      ],
                      rows: locationsId
                        .find((x) => x.locationID === selectedLocation)
                        .skus.map((s) => ({
                          customerCode: s.customerCode ?? "All",
                          vendorCode: s.vendorCode ?? "All",
                          skuCode: s.skuCode ?? "All",
                          action: (
                            <MDBox>
                              
                            </MDBox>
                          ),
                        })),
                    }}
                  /> */}
                  {/* <BasicTable columns={columns} data={detail} /> */}
                  <div style={{ height: 500, width: "100%" }}>
                      <EditableStyledDataGrid
                        autoHeight={false}
                        columns={columns}
                        rows={detail}
                        disableRowSelectionOnClick={true}
                        sx={{
                          borderRadius: "0.75rem",
                        }}
                        initialState={{
                          pagination: { paginationModel: { pageSize: 25 } },
                        }}
                        getRowHeight={() => "auto"}
                        processRowUpdate={handleRowUpdate}
                        onProcessRowUpdateError={handleProcessRowUpdateError}
                        hideFooterSelectedRowCount={true}
                        isCellEditable={isCellEditable}
                      />
                    </div>
                </Grid>
              </Grid>
            </Fragment>
          )}

          {/* <Fragment> */}
            {/*delete button */}
            {/* <MDBox mt={2} width="100%" display="flex" justifyContent="center"> */}
              {/* {selectedLocation !== null && (
                <MDButton
                  sx={{ marginLeft: "1.5rem" }}
                  type="button"
                  onClick={() => {
                    renderDialog({
                      locationID: selectedLocation,
                      mode: "location",
                    });
                  }}
                  variant="gradient"
                  color="error"
                >
                  Delete Selected Location
                </MDButton>
              )} */}
              {/* <BackButton url="/setup/pickface-location" />
            </MDBox>
          </Fragment> */}
        </MDBox>
      </>
    </MDBox>
  );
}

// const LocationTable = ({ tableData, existingRecord, selectedLocation, setSelectedLocation }) => {
//   const LocationTableCell = ({ cellData, onClick }) => {
//     const cellStyle = {
//       fontWeight: existingRecord.some((x) => x.locationID === cellData) ? "700" : "300",
//       backgroundColor: existingRecord.some((x) => x.locationID === cellData)
//         ? selectedLocation === cellData
//           ? "Cyan"
//           : "Gainsboro"
//         : "white", // Change the color based on isSelected state
//       border: "1px solid black",
//     };

//     return (
//       <TableCell style={cellStyle} onClick={onClick}>
//         {cellData}
//       </TableCell>
//     );
//   };

//   const handleCellClick = (e) => {
//     const selectedLocRow = tableData.find(x => x.some(y => y.trim() === e.target.innerText));
//     const selectedLocID = selectedLocRow ? selectedLocRow.find(x => x.trim() === e.target.innerText) : null;
//     if (selectedLocID) {
//       if (
//         selectedLocID !== selectedLocation &&
//         existingRecord.some((x) => x.locationID === selectedLocID)
//       ) {
//         setSelectedLocation(selectedLocID);
//       }
//     }
//   };

//   return (
//     <Table style={{ borderCollapse: "collapse", marginBottom: "10px" }}>
//       <TableBody>
//         {tableData.map((row, rowIndex) => (
//           <TableRow key={rowIndex}>
//             {row.map((cellData, columnIndex) => (
//               <LocationTableCell
//                 key={`${rowIndex}-${columnIndex}`}
//                 cellData={cellData}
//                 onClick={(e) => handleCellClick(e)}
//               />
//             ))}
//           </TableRow>
//         ))}
//       </TableBody>
//     </Table>
//   );
// };

export default RemovePickFaceLocationInfo;
